import React from 'react';
import styled from 'styled-components';


// import GlobalStyled from '../styles/GlobalStyle';

function AgentContactInfo({agent_info}){
        if (agent_info.agent) {
            return (
                <StyledAgent>{agent_info.name}<br />{agent_info.company} <br/>{agent_info.mobile_phone} (mobile)<br/>{agent_info.office_phone} (office)<br/>{agent_info.mls_info} </StyledAgent>
            )
        }
        return <StyledAgent>{agent_info.name}<br />Call or Text: {agent_info.phone}<br />Email: {agent_info.email} </StyledAgent>
}

const StyledAgent = styled.div`
    font-size:1rem;
    // border: solid 2px green;
    width:75%;
    text-align:left;
    margin:auto;
    `;

export default AgentContactInfo;